export const ROUTE_PATHS = {
  LOGIN_EMAIL: "/login-email",
  LOGIN_MOBILE: "/login-mobile",
  FORGOT_PASSWORD: "/forgot-password",
  LOGIN_ANOTHER_WAY: "/login-another-way",
  OTP: "/otp",
  SELECT_TENANT: "/select-tenant",
  SIGNUP: "/signup",
  LOGIN: "/login",
  DASHBOARD: "/dashboard",
  RESET_PASSWORD: "/reset-password",
  RESET_PASSWORD_WITH_TOKEN: "/reset-password",
  HOME: "/sample/",
  IMPACT_HOME: "/impact-home/",
  ACCOUNT: "/account",
  DEFAULT: "*",
  PROFILE: "/profile",
  USER_SETUP: "/user-setup",
  ACCOUNT_SETUP: "/account-setup",
};

export const API_CODES = {
  SUCCESS_CODE: "SUCCESS",
  FAILURE_CODE: "FAILURE",
};

export const CONFIG = {
  SUPPORTED_FORMATS: ["image/jpg", "image/jpeg", "image/png"],
};
